"use strict";

var stackTypes = {
  SINGLE: 'single',
  MULTIPLE: 'multiple'
};
module.exports = {
  stackTypes: stackTypes
};